import React from "react";
import "./Nosotros.css";
import { FaBullseye, FaEye, FaHeart, FaBookOpen } from "react-icons/fa";

const Nosotros = () => {
  return (
    <div className="nosotros-background">
      <div className="nosotros-container">
        <header className="nosotros-header">
          <h1>¿Quiénes Somos?</h1>
          <p>Conoce más sobre AITA y nuestro compromiso contigo.</p>
        </header>

        <section className="cards">
          <div className="historia">
          <FaBookOpen className="icono" />
            <h2>Nuestra Historia</h2>
            <p>
              AITA nació con la visión de ofrecer soluciones prácticas y accesibles
              para cada hogar mexicano. Desde nuestros inicios, hemos trabajado con
              pasión para convertirnos en una empresa confiable y cercana a nuestros clientes,
              brindando electrodomésticos, tecnología, artículos para el campo y la construcción,
              adaptados a las necesidades de cada familia y sector. Actualmente trabajamos con más
              de 20 establos de la Empresa GTH y Grupo Vitri, además de Grupo Mercantil Ferretera,
              Grupo Muma y con Grupo SIMSA en más de 10 razones sociales.
            </p>
          </div>

          <div className="mision">
            <FaBullseye className="icono" />
            <h3>Misión</h3>
            <p>
            Ser la empresa con el mejor servicio de México, ofreciendo a nuestros 
            clientes precios competitivos y respaldados por una excelencia operativa
            que garantiza su satisfacción en cada interacción.
            </p>
          </div>

          <div className="vision">
            <FaEye className="icono" />
            <h3>Visión</h3>
            <p>
              Crear relaciones honestas y amistosas con la mayor cantidad de clientes posibles,
              para que, a través de la venta de productos y el servicio, podamos mejorar la calidad
              de vida de los mexicanos.
            </p>
          </div>
        </section>

        <section className="valores">
          <h3><FaHeart className="icono" /> Valores</h3>
          <ul>
            <li>Compromiso</li>
            <li>Confianza</li>
            <li>Calidez</li>
            <li>Responsabilidad</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Nosotros;
